import { useRequiredConfirmDialog } from '@if/mui'
import { TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/**
 * The save came back in conflict: someone else changed the loan while the calendar was
 * being edited, so what is on screen no longer describes anything the server would accept.
 * There is nothing left to choose — the dialog hides Cancel and refuses dismissal, and
 * confirming refetches the loan.
 */
export const useSaveConflictDialog = (refetch: () => void) => {
  const { t } = useTranslation()

  return useRequiredConfirmDialog({
    icon: TriangleAlert,
    title: t('loan.conflict.title'),
    message: t('loan.conflict.message'),
    onConfirm: refetch,
  })
}
